import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { CommonService } from 'src/app/shared/services/common.service';
import { JsignalService } from 'src/app/shared/services/jsignal.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { UserRoutingModule } from '../../user-routing/user-routing.module';
import { ComputerizedSystemLibraryComponent } from '../computerized-system-library.component';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { AsignUserRoleService } from 'src/app/shared/services/asign-user-role.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-computerized-system-library-popup',
  templateUrl: './computerized-system-library-popup.component.html',
  styleUrl: './computerized-system-library-popup.component.scss',
  standalone: false
})
export class ComputerizedSystemLibraryPopupComponent implements OnInit {
    components: { buttonRenderer: typeof Actionbutton; };
    backgroundColorButton: string;
    backgroundColorScreen: string;
    FormValid!: FormGroup;
    buttonName = 'Save';
  workspaceId: number;


  constructor(
    private fb: FormBuilder,
    public dialogref: MatDialogRef<ComputerizedSystemLibraryComponent>,
     private validation: validationmethod, 
     private localStorage: LocalStorageSettingsService,
    private commonService: CommonService,
     private errorMsg: ErrorMessages, 
     private asignUserRoleService: AsignUserRoleService,
      private spinner: NgxUiLoaderService, 
      private snackBar: MatSnackBar, 
      @Inject(MAT_DIALOG_DATA) public data: any,

      ) {
  
    this.components = {

      buttonRenderer: Actionbutton,

    };

  }

    ngOnInit(): void {

  this.backgroundColorButton = this.localStorage.getSettings("ColorA");
  this.backgroundColorScreen = this.localStorage.getSettings("ColorD");
  this.workspaceId = Number(this.localStorage.getSettings("WorkspaceId"));

  this.buildForm();

  if (this.data) {

    this.buttonName = "Update";

    this.FormValid.patchValue({
      systemCode: this.data.systemCode,
      systemName: this.data.systemName,
      description: this.data.description
    });

  }

}

buildForm(): void {

  this.FormValid = this.fb.group({

    systemCode: [
      '',
      [
        Validators.required,
        Validators.maxLength(100)
      ]
    ],

    systemName: [
      '',
      [
        Validators.required,
        Validators.maxLength(200)
      ]
    ],

    description: [
      '',
      [
        Validators.maxLength(5000)
      ]
    ]

  });

}
  
updateData(): void {

  if (this.FormValid.invalid) {
    this.FormValid.markAllAsTouched();
    this.snackBar.open("All mandatory fields to be filled", "Ok", { duration: 3000 });
    return;
  }

  const payload = {
    ...this.data,            // preserves id in edit mode
    ...this.FormValid.value,
    "status": "Yes",
    "workspaceId":this.workspaceId
  };

  console.log("PAyload in popup : ",payload);

  this.dialogref.close({
    action: this.buttonName === 'Save' ? 'save' : 'update',
    data: payload
  });
}

close(): void {
  this.dialogref.close();
}

}